// Utilities
import { builderFetch } from '@builder/core/utilities';
const { isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.item.setActionSchedule;

/**
 * Sets the schedule status of an action
 *
 * @param {Number} itemID The item ID
 * @param {Object} fields The fields to be saved in the meta for the schedule
 * @return {Promise} The apiFetch promise
 */
const setSchedule = async ( itemID, fields = {} ) => {
	// Get the action
	const action = UncannyAutomator._core.recipe.item.getItemAction( itemID );

	// If the item is not define, stop here
	if ( isEmpty( action ) ) {
		throw new Error( `setSchedule: The action ${ itemID } doesn't exist` );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: 'schedule_action',
		method: 'POST',
		data: Object.assign( {
			recipeId: UncannyAutomator._recipe.recipe_id,
			actionId: itemID
		}, fields ),
		snackbar: {
			loading: fields.asyncMode === 'delay' ? strings.delayLoading : strings.scheduleLoading,
			success: fields.asyncMode === 'delay' ? strings.delayUpdated : strings.scheduleUpdated,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/action-schedule/set-schedule', {
				detail: {
					actionID: itemID,
					fields: fields
				}
			} ) );
		}

		return response;
	} );
}

export default setSchedule;
